import { ejecutarExpresion } from '../motor/ejecutarExpresion.js'

function extraerPlaceholder(xml, startIndex) {
  const n = xml.length
  let j = startIndex + 2
  let depth = 1

  while (j < n && depth > 0) {
    const c = xml[j]
    if (c === '{') depth++
    else if (c === '}') depth--
    j++
  }

  if (depth !== 0) return null
  const tag = xml.slice(startIndex, j)
  const contenido = tag.replace(/^\$\{|\}$/g, '')
  return { tag, contenido, endIndex: j }
}

export function reemplazarTextoPlano(xml, datos, errors = [], runtimeContext = {}) {
  let resultado = ''
  let i = 0

  while (i < xml.length) {
    const start = xml.indexOf('${', i)
    if (start === -1) {
      resultado += xml.slice(i)
      break
    }

    resultado += xml.slice(i, start)
    const ph = extraerPlaceholder(xml, start)

    if (!ph) {
      // Placeholder sin cierre: copiar literal
      resultado += xml.slice(start, start + 2)
      i = start + 2
      continue
    }

    const contenido = ph.contenido.trim()

    // 1️⃣ NO tocar imágenes
    if (contenido.startsWith('i:')) {
      resultado += ph.tag
      i = ph.endIndex
      continue
    }

    try {
      // 2️⃣ Variables normales v:
      if (contenido.startsWith('v:')) {
        const valor = ejecutarExpresion(contenido, datos, errors, runtimeContext)
        resultado += valor ?? ''
        i = ph.endIndex
        continue
      }

      // 3️⃣ Funciones personalizadas
      if (/^[a-zA-Z0-9_]+:/.test(contenido)) {
        const valor = ejecutarExpresion(contenido, datos, errors, runtimeContext)
        resultado += valor ?? ''
        i = ph.endIndex
        continue
      }

      // 4️⃣ Placeholder desconocido → dejarlo igual
      resultado += ph.tag
      i = ph.endIndex
    } catch (e) {
      console.error('Error evaluando placeholder:', ph.tag, e)
      resultado += ph.tag
      i = ph.endIndex
    }
  }

  return resultado
}
